import { fetcher } from '../utils'
import { ComponentFlowMessageVO, ComponentMessageVO } from '@repo/types'

export default async (input: ComponentFlowMessageVO): Promise<ComponentMessageVO> =>
  fetcher(`/api/chats/flow/send`, 'POST', input)
